import React from "react";
import { PropTypes } from "prop-types";
import {
    UserStationExpirationCell,
    UserListEmptyState,
} from "administration/user/components";
import { MrbGrid } from "mrb/components/grid";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbLineContentLoader } from "mrb/components/loader";

function UserStationExpirationTemplate({ userStationExpirationViewStore, t }) {
    const { gridStore, queryUtility } = userStationExpirationViewStore;
    return (
        <div>
            <div className="u-mar--bottom--sml">
                <MrbQuerySearchInput
                    queryUtility={queryUtility}
                    showSearchButton={false}
                />
            </div>
            <MrbGrid
                emptyStateRender={UserListEmptyState}
                loaderRender={() => (
                    <MrbLineContentLoader
                        setWidth={1024}
                        lineheight={60}
                        setY={68}
                        rows={10}
                        backgroundColor={"#33363B"}
                        foregroundColor={"#393C42"}
                    />
                )}
                classNameOverride="c-card--list"
                store={gridStore}
                t={t}
                cellRender={(props) => (
                    <UserStationExpirationCell
                        userStationExpirationViewStore={
                            userStationExpirationViewStore
                        }
                        {...props}
                    />
                )}
            />
        </div>
    );
}

UserStationExpirationTemplate.propTypes = {
    userStationExpirationViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default UserStationExpirationTemplate;
